import React from 'react';
import PropTypes from 'prop-types';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import SpacerRow from '@zg-rentals/multibrand-ui/lib/SpacerRow';
import CaretDownIcon from '@zg-rentals/multibrand-ui/lib/icons/CaretDown';
import CaretUpIcon from '@zg-rentals/multibrand-ui/lib/icons/CaretUp';
import ContentBox3 from '@zg-rentals/multibrand-ui/lib/ContentBox3';
import ContactSupport from '../ContactSupport';
import { FaqModel } from '@common/types';

import './index.scss';

interface IFaqComponentProps {
  faqs: FaqModel[];
  title?: string;
  showContactSection?: boolean;
  wrapperElement?: any;
  headerAction?: JSX.Element;
  onFAQClick?: () => any;
}

class FaqComponent extends React.Component<IFaqComponentProps> {
  static defaultProps = {
    title: 'You may be wondering...',
    showContactSection: true,
    wrapperElement: ContentBox3,
  };

  static propTypes = {
    faqs: PropTypes.array.isRequired,
    title: PropTypes.string,
    showContactSection: PropTypes.bool,
    wrapperElement: PropTypes.elementType,
    onFAQClick: PropTypes.func,
  };

  state = {
    openIndex: null,
  };

  toggleOpenFaq = (index) => () => {
    const { openIndex } = this.state;
    if (this.props.onFAQClick && openIndex !== index) {
      this.props.onFAQClick();
    }
    this.setState({ openIndex: openIndex === index ? null : index });
  };

  getContactUsFaq = () => ({
    question: 'Still have questions? Contact us',
    answer: <ContactSupport />,
  });

  renderFaqRow = ({ question, answer, index, faqLength }) => {
    const { openIndex } = this.state;
    const isOpen = index === openIndex;
    const CaretIcon = isOpen ? CaretUpIcon : CaretDownIcon;
    const isLastElement = index + 1 === faqLength;

    return (
      <div key={question} data-index={index}>
        <Row className="pan">
          <div className="cursorPointer" onClick={this.toggleOpenFaq(index)}>
            <Col xs={11}>
              <Text type="body-small" emphasize>
                {question}
              </Text>
            </Col>
            <Col xs={1}>
              <CaretIcon size="sm" />
            </Col>
          </div>
          {isOpen && (
            <Col xs={12}>
              <Text type="body-small" className="answer-body">
                {answer}
              </Text>
            </Col>
          )}
          {!isLastElement && <hr className="FaqComponent-hr" />}
        </Row>
      </div>
    );
  };

  renderFaqs = () => {
    const { faqs, showContactSection } = this.props;
    const allFaqs = [...faqs, ...(showContactSection ? [this.getContactUsFaq()] : [])];

    return (
      <SpacerRow>
        {allFaqs.map(({ question, answer }, index) =>
          this.renderFaqRow({
            question,
            answer,
            index,
            faqLength: allFaqs.length,
          }),
        )}
      </SpacerRow>
    );
  };

  render() {
    const { wrapperElement: Wrapper, title, headerAction } = this.props;
    return (
      <Wrapper data-auto-test-id="faq-component">
        {title && (
          <div className="faq-header">
            <Text type="body" emphasize>
              {title}
            </Text>
            {headerAction && headerAction}
          </div>
        )}
        {this.renderFaqs()}
      </Wrapper>
    );
  }
}

export default FaqComponent;
